module.exports = __webpack_public_path__ + "media/components/assets/img/icons/payments-b55669cd96192aec89cf32b07a2ddd56.svg";